import { inject, Injectable, signal } from '@angular/core';
import { LocalStorageDataAccess } from '@softline/core';
import {
  DEFAULT_SALES_CONFIG,
  SalesModuleConfig,
} from '../sales.shared';

const STORAGE_KEY = 'sales.config';

@Injectable({ providedIn: 'root' })
export class SalesConfigService {
  private readonly dataAccess = inject(LocalStorageDataAccess);

  readonly config = signal(this.loadFromStorage());

  private loadFromStorage(): Required<SalesModuleConfig> {
    const stored = this.dataAccess.get({ key: STORAGE_KEY });
    return { ...DEFAULT_SALES_CONFIG, ...(stored ?? {}) } as Required<SalesModuleConfig>;
  }

  load(): Required<SalesModuleConfig> {
    return this.config();
  }

  save(config: SalesModuleConfig): void {
    this.dataAccess.set({ key: STORAGE_KEY }, config);
  }

  reset(): void {
    this.dataAccess.set({ key: STORAGE_KEY }, DEFAULT_SALES_CONFIG);
    this.config.set({ ...DEFAULT_SALES_CONFIG } as Required<SalesModuleConfig>);
  }
}
